import React from "react";
import "../../styles/AgendaPage.scss";


export default function AgendaPage() {

  return (
    <div className="agenda-wrapper">

      <header className="agenda-header">
        <div className="agenda-header-bg" />       
        <div className="agenda-header-content">
            <h1 className="agenda-page-title a-cutout-text" data-text="Agenda">Program</h1>
            <h2 className="agenda-page-title a-cutout-text sub"  data-text="APLIC 2027">APLIC 2027</h2>
        </div>
      </header>

      <section className="agenda-page-section">
        <div className="agenda-page-container">
          <h2 className="agenda-title"></h2>

        </div>
      </section>
    </div>
  );
}
